import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

export interface ConfigState {
  history: {
    zoomBox: {
      viewScale: number;
      areaScale: number;
    };
  };
}

const { persistAtom } = recoilPersist();

export const configState = atom<ConfigState>({
  key: 'config',
  default: {
    history: {
      zoomBox: {
        viewScale: 3,
        areaScale: 0
      }
    }
  },
  effects_UNSTABLE: [persistAtom]
});
